import type { MechKey } from './keys';

export const sw: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mekanika · 2D',
  'panel.scene': 'Eneo',
  'panel.dims': 'Vigezo',
  'panel.style': 'Muonekano',
  'panel.action': 'Udhibiti',
  'style.body': 'Mwili',
  'style.vector': 'Vektori',
  'style.ground': 'Ardhi',
  'style.forces': 'Onyesha nguvu',
  'style.trace': 'Onyesha mkondo',
  'style.labels': 'Lebo za vektori',
  'hint.line1': 'Bonyeza cheza kuanza · buruta miili kuihamisha',
  'hint.line2': 'Sandbox: chagua umbo, kisha bonyeza kuweka',
  'scene.incline': 'Ndege iliyoinama',
  'scene.projectile': 'Mwendo wa mradi',
  'scene.pendulum': 'Pendulum',
  'scene.springMass': 'Mfumo wa chemchemi-masi',
  'scene.collisions': 'Migongano',
  'scene.atwood': 'Mashine ya Atwood',
  'scene.circular': 'Mwendo wa mviringo',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'pembe (°)',
  'dim.friction': 'msuguano',
  'dim.mass': 'masi',
  'dim.massA': 'masi A',
  'dim.massB': 'masi B',
  'dim.velocity': 'kasi',
  'dim.angleLaunch': 'pembe ya uzinduzi (°)',
  'dim.gravity': 'mvuto',
  'dim.gravityX': 'mvuto x',
  'dim.gravityY': 'mvuto y',
  'dim.length': 'urefu',
  'dim.damping': 'upunguzaji',
  'dim.spring': 'ugumu',
  'dim.restitution': 'urejesho',
  'dim.radius': 'radi',
  'dim.speed': 'mwendo',
  'action.play': 'Cheza',
  'action.pause': 'Simama',
  'action.step': 'Hatua',
  'action.reset': 'Weka upya',
  'action.speed': 'Kasi',
  'action.clear': 'Futa',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Mvuto',
  'forceName.normal': 'Nguvu ya kawaida',
  'forceName.friction': 'Nguvu ya msuguano',
  'forceName.tension': 'Mvutano',
  'forceName.spring': 'Nguvu ya chemchemi',
  'forceName.applied': 'Nguvu iliyotumika',
  'forceName.air': 'Upinzani wa hewa',
  'palette.box': 'Sanduku',
  'palette.circle': 'Mpira',
  'palette.ramp': 'Mteremko',
  'palette.ground': 'Ardhi',
  'palette.hint': 'Chagua umbo, kisha bonyeza kwenye turubai kuweka.',
  'panel.forces': 'Nguvu zilizoona',
  'forces.empty': 'Bado hakuna — cheza eneo',
};
